import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';

const PresentationViewer = () => {
  const { slug } = useParams<{ slug: string }>();
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Build the presentation URL
  const presentationUrl = `/presentations/${slug}/index.html`;

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen();
      setIsFullscreen(false);
    }
  };

  return (
    <div className={`${isFullscreen ? '' : 'min-h-screen bg-gray-900'}`}>
      {/* Controls bar - hidden in fullscreen */}
      {!isFullscreen && (
        <div className="bg-gray-800 border-b border-gray-700 px-4 py-2 flex justify-between items-center">
          <Link
            to="/presentations"
            className="text-sm text-gray-400 hover:text-white flex items-center gap-2"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Presentations
          </Link>

          <div className="flex items-center gap-4">
            <button
              onClick={toggleFullscreen}
              className="text-sm text-gray-400 hover:text-white flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                />
              </svg>
              Fullscreen
            </button>

            <a
              href={presentationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-white flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
              Open in New Tab
            </a>
          </div>
        </div>
      )}

      {/* Presentation iframe */}
      <iframe
        src={presentationUrl}
        className={`w-full border-0 ${isFullscreen ? 'h-screen' : 'h-[calc(100vh-48px)]'}`}
        title={`Presentation: ${slug}`}
        allow="fullscreen"
      />

      {/* Instructions overlay - show briefly on load */}
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 bg-black/75 text-white text-sm px-4 py-2 rounded-lg opacity-0 animate-fade-in-out pointer-events-none">
        Use arrow keys to navigate slides
      </div>
    </div>
  );
};

export default PresentationViewer;
